import { useAuth } from "../../context/auth-context.js";
import { initialsOf } from "../../lib/utils.js";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar.js";
import { Badge } from "../ui/badge.js";
import { Card, CardDescription, CardHeader, CardTitle } from "../ui/card.js";

/**
 * The signed-in user's identity. Read-only: the API has no self-service
 * profile update (names are changed through the admin `adminUpdateUser`).
 */
export const ProfileCard = ({ image }: { image?: string | null }) => {
  const { data } = useAuth();
  if (!data) return null;
  const { user } = data;

  return (
    <Card>
      <CardHeader className="flex flex-row items-start gap-4 space-y-0">
        <Avatar className="size-14 ring-2 ring-background">
          {image ? <AvatarImage src={image} alt={user.name ?? user.email} /> : null}
          <AvatarFallback>{initialsOf(user.name, user.email)}</AvatarFallback>
        </Avatar>
        <div className="flex flex-1 flex-col gap-1">
          <CardTitle className="leading-tight">{user.name ?? user.email}</CardTitle>
          <CardDescription className="flex flex-wrap items-center gap-2 text-xs">
            <span>{user.email}</span>
            <Badge variant="muted">{user.role}</Badge>
          </CardDescription>
        </div>
      </CardHeader>
    </Card>
  );
};
